<template>
    <div>
        <!-- style="transform: scale(0.78); width: 112%; margin-left: -10%;" -->
        <page-title heading="Laporan Komisi"
            class="layout-gantung ninja-shadow" />

        <div class="container-fluid">
            <div class="card card-box ninja-shadow">
                <div class="card-body">
                    <b-row class="head-filter">
                        <b-col class="pr-0">
                            <label class="lb-header-filter"
                                style="margin-bottom:15px;">Hari,
                                Tanggal</label>
                            <date-picker v-model="from"
                                type="date"
                                range
                                format="DD-MM-YYYY"
                                value-type="YYYY-MM-DD"
                                placeholder="DD-MM-YYYY"
                                :style="'width: 100%'"
                                @input="searchValueChanged($event, 'from')"
                                id="date-picker-commision">
                            </date-picker>
                        </b-col>
                        <b-col class="pr-0">
                            <label class="lb-header-filter">Jenis User</label>
                            <vue-select-clearable :options="userTypeOpt"
                                v-model="user_type"
                                :placeholder="'Semua Jenis User'"
                                @input="
                                  searchValueChanged(
                                    $event == null ? '' : $event.id,
                                    'user_type'
                                  )
                                "
                                class="mt-2"
                                style="width:100%;background-color:#ffffff;">
                                <template slot="option"
                                    slot-scope="option">
                                    {{ option.label }}
                                </template>
                                <template slot="selected-option"
                                    slot-scope="option">
                                    {{ option.label }}
                                </template>
                            </vue-select-clearable>
                        </b-col>
                        <b-col class="pr-0">
                            <label class="lb-header-filter">Nama User</label>
                            <b-input-group>
                                <b-form-input class="mt-2"
                                    v-model="user_name"
                                    placeholder="Nama User"
                                    @input="searchValueChanged($event, 'user_name')">
                                </b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col></b-col>
                    </b-row>
                    <div class="stright-line"></div>
                    <b-col md="12">
                        <DataTableWrapper :perPage="perPage"
                            :customEntryOptions="{f: [5]}"
                            :fromPage="fromPage"
                            :toPage="toPage"
                            :totalEntries="totalEntries"
                            :currentPage="currentPage"
                            :callbackFunc="fetchListLaporanKomisi"
                            @valueChanged="handleValueChanged">
                            <template v-slot:right-header>
                                <b-button variant="primary"
                                    class="align-self-end mr-3"
                                    @click="downloadLaporanKomisi">
                                    Download Komisi
                                </b-button>
                            </template>

                            <b-table :items="laporanKomisiList"
                                :fields="fieldList"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                thead-tr-class="izd-datatable"
                                :no-local-sorting="true"
                                id="report-commission-table">

                                <template v-slot:cell(total_komisi)="data">
                                    {{
                                        data.value > '0'
                                        ? `Rp. ${data.value.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")},-`
                                        : '-'
                                    }}
                                </template>
                                <template v-slot:cell(actions)="data">
                                    <span>
                                        <b-dropdown id="dropdown-1"
                                            class="m-md-2 text-capitalize"
                                            variant="primary"
                                            size="sm"
                                            right>
                                            <template v-slot:button-content>
                                                <font-awesome-icon
                                                    icon="copy" />
                                            </template>
                                            <b-dropdown-item @click="
                                                detailReportComission({
                                                    user_id: data.item.user_id,
                                                    role_id: data.item.role_id,
                                                    start_date: from[0],
                                                    end_date: from[1]
                                                })
                                            ">
                                                Lihat Detail
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </span>
                                </template>

                            </b-table>
                        </DataTableWrapper>
                    </b-col>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import debounce from "lodash/debounce";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
moment.locale("id");

import {
    faCopy,
    faDownload,
    faSearch
} from "@fortawesome/free-solid-svg-icons";

library.add(faCopy, faDownload, faSearch);

export default {
    components: {
        DataTableWrapper: () => import("../../components/DataTableWrapper"),
        "vue-select-clearable": () => import("@/components/VueSelectClearable.vue"),
        DatePicker
    },
    data() {
        return {
            firstLoadKomisi: true,
            userTypeOpt: [],

            user_type: null,
            user_name: "",
            from: [moment().startOf('month').format('YYYY-MM-DD'), moment().format("YYYY-MM-DD")],
            to: null,

            perPage: 10,
            currentPage: 1,
            rows: 0,
            fromPage: 0,
            toPage: 0,
            totalEntries: 0,
            sortBy: "",
            sortDesc: false,
            searchValue: [],
            laporanKomisiList: []
        };
    },
    computed: {
        ...mapGetters(["getKlinikId", "klinikUser"]),
        fieldList() {
            const {
                generateFieldList: g,
                setSearchableAndSortableFieldList: s
            } = this;
            const r = val => Boolean(/(no|actions|viewed)\b/gi.test(val) ? !1 : 1);
            return (
                [
                    { key: "nama_user" },
                    { key: "jenis_user" },
                    { key: "total_komisi" },
                    { 
                        key: "actions", 
                        thStyle: "width: 120px"
                    }
                ]
                |> (v => s({ field: v, customFunc: r }))
                |> (z => g({ field: z }))
            );
        }
    },
    created() {
        this.getUserType();
    },

    watch: {
        currentPage(val) {
            this.fetchListLaporanKomisi();
        },
        perPage() {
            this.fetchListLaporanKomisi();
        },
        sortBy() {
            this.fetchListLaporanKomisi();
        },
        sortDesc() {
            this.fetchListLaporanKomisi();
        },
        searchValue: {
            handler: function (val) {
                if (!this.firstLoadKomisi) this.fetchListLaporanKomisi();
            },
            deep: true
        }
    },
    methods: {
        getTodayDate() {
            return [moment().startOf('month').format('YYYY-MM-DD'), moment().format("YYYY-MM-DD")];
        },
        getSampleData() {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve({
                        status: true,
                        data: {
                            total: 10,
                            from: 1,
                            to: 10,
                            data: [
                                {
                                    "id": 1,
                                    "nama_user": "Anindita",
                                    "jenis_user": "Perawat",
                                    "total_komisi": 120000
                                },
                                {
                                    "id": 2,
                                    "nama_user": "lorem",
                                    "jenis_user": "Perawat",
                                    "total_komisi": 120000
                                },
                                {
                                    "id": 3,
                                    "nama_user": "Aa",
                                    "jenis_user": "Perawat",
                                    "total_komisi": 120000
                                },
                                {
                                    "id": 4,
                                    "nama_user": "Bb",
                                    "jenis_user": "Perawat",
                                    "total_komisi": 120000
                                },
                                {
                                    "id": 5,
                                    "nama_user": "Anindita",
                                    "jenis_user": "Perawat",
                                    "total_komisi": 120000
                                },
                                {
                                    "id": 6,
                                    "nama_user": "lorem",
                                    "jenis_user": "Perawat",
                                    "total_komisi": 120000
                                },
                                {
                                    "id": 7,
                                    "nama_user": "Aa",
                                    "jenis_user": "Perawat",
                                    "total_komisi": 120000
                                },
                                {
                                    "id": 8,
                                    "nama_user": "Bb",
                                    "jenis_user": "Perawat",
                                    "total_komisi": 120000
                                },
                                {
                                    "id": 9,
                                    "nama_user": "Anindita",
                                    "jenis_user": "Perawat",
                                    "total_komisi": 120000
                                },
                                {
                                    "id": 10,
                                    "nama_user": "lorem",
                                    "jenis_user": "Perawat",
                                    "total_komisi": 120000
                                },
                                {
                                    "id": 11,
                                    "nama_user": "Aa",
                                    "jenis_user": "Perawat",
                                    "total_komisi": 120000
                                },
                                {
                                    "id": 12,
                                    "nama_user": "Bb",
                                    "jenis_user": "Perawat",
                                    "total_komisi": 120000
                                }
                            ]
                        }
                    });
                }, 500);
            });
        },
        async getUserType() {
            const response = await this.$axios.get(`klinik/list-role`);

            const { data, status } = response.data;
            if (status) {
                this.userTypeOpt = data.map(res => ({
                    ...res,
                    label: res.display_name,
                    value: res.display_name
                }));
            }
        },
        async fetchListLaporanKomisi() {
            if (this.firstLoadKomisi) {
                this.searchValue = [
                    {
                        key: "from",
                        value: this.from
                    }
                ];
            }

            let response = await this.$axios.get(
                `klinik/laporan-komisi?klinik_id=${this.getKlinikId
                }&limit=${this.perPage}&page=${this.currentPage
                }${this.determineParameter()}`
            );
            this.firstLoadKomisi = false;
            const { status, data } = response.data;

            if (status) {
                const {
                    data: laporanKomisiList,
                    total: totalEntries,
                    to: toPage,
                    from: fromPage
                } = data; //data.data

                this.laporanKomisiList = laporanKomisiList;
                this.rows = totalEntries || 0;
                this.toPage = toPage || 0;
                this.fromPage = fromPage || 0;
                this.totalEntries = totalEntries;

                return this;
            }
        },
        // SETTING TABLE
        handleValueChanged({ perPage, currentPage }) {
            perPage && (perPage |> (_ => (this.perPage = _)));
            currentPage && (currentPage |> (_ => (this.currentPage = _)));
        },
        searchValueChanged: debounce(function (val, key) {
            if (key == "from" && val[0] == null && val[1] == null) {
                val = this.from = this.getTodayDate()
            }
            const { searchValue } = this;

            const z = searchValue.filter(item => item.key !== key);

            this.searchValue = [
                ...z,
                {
                    key,
                    value: val
                }
            ];

        }, 500),
        async detailReportComission({ user_id, role_id, start_date, end_date } = {}) {
            if (user_id && role_id) {
                this.$router.push({
                    name: "klinik-komisi-report-detail",
                    params: {
                        user_id: user_id,
                        role_id: role_id
                    },
                    query: {
                        start_date,
                        end_date
                    }
                });
            }
        },
        determineParameter() {
            const { searchValue, sortBy, sortDesc } = this;
            let v = "";

            searchValue.map(item => {
                const x = item.key;
                if (item.key == "from") {
                    v += `&from=${item.value[0] || ""}`;
                    v += `&to=${item.value[1] || ""}`;
                } else {
                    v += `&${x}=${item.value || ""}`;
                }
            });

            if (sortBy) {
                v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
            }

            return v;
        },
        async downloadLaporanKomisi() {
            const res = await this.$axios.get(
                `klinik/laporan-komisi/export?klinik_id=${this.getKlinikId
                }${this.determineParameter()}`
            );

            const { status, data } = res.data;

            if (status) {
                let link = document.createElement("a");
                link.href = data.link;
                link.setAttribute("download", data.name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.selectedId = [];
            } else {
                this.$swal({
                    text: "Something went wrong",
                    type: "error"
                });
            }
        },
    }
};
</script>
  
<style scoped lang="css">
.bg-kuning {
    background: #f7fc6b;
}

.bg-kuning,
.bg-danger,
.bg-first {
    color: black !important;
}

.no-padding {
    padding: 0 !important;
}

.page-item.active a {
    background: #3b86ff;
    border: none !important;
}

.ninja-shadow {
    box-shadow: 0px 8px 15px 0px lightgrey;
}

.head-filter {
    margin: 20px 0;
}

.lb-header-filter {
    color: #217fc3;
    font-weight: 600;
}
</style>
    
<style lang="css">
.tooltip {
    display: block !important;
    z-index: 10000;
}

.tooltip .tooltip-inner {
    background: rgb(18, 106, 207);
    color: white;
    border-radius: 5px;
    padding: 5px 10px 4px;
    box-shadow: 0px 0px 0px rgba(black, .1) !important;
}

.tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: rgb(18, 106, 207);
    z-index: 1;
}

#date-picker-commision .mx-input {
    height: 41.7px !important;
}

#report-commission-table.b-table>thead>tr>[aria-sort]:not(.b-table-sort-icon-left) {
    background-position: right calc(16rem / 2) top 15px !important;
    padding-right: calc( 4rem + 0.65em );
}
</style>
  